import HoursGrid from '@assets/hours-grid-vertical.png';
import React from 'react';
import styled from 'styled-components';
import { media } from '../../../components/style-utils';
import { Black, H3, H5 } from '../../../components/Typography/Typography';

export const SectionThisWay = function() {
  return (
    <Container>
      <Header>Think&nbsp;about&nbsp;it this&nbsp;way:</Header>
      <Box>
        <TextBox>
          <Headline>Every week has 168 hours.</Headline>
          <Text style={{ marginTop: 0 }}>And how do our churches use this time?</Text>
          <Text>We pour the majority of our resources & budget into a 1-hour in-person service.</Text>
          <Text>This made sense 25 years ago. But in 2020? This model lacks balance.</Text>
          <Text>
            <Black>Here’s the bottom line:</Black>
            <br />
            <em>Churches that refuse to reevaluate this approach are putting themselves in vulnerable positions.</em>
          </Text>
          <Text>
            <Black>Why?</Black>
            <br />
            Because there are 167 hours beyond your Sunday service every single week.
          </Text>
          <Text>
            And thanks to digital platforms, you can use those 167 hours to fulfill your church’s mission, share the
            hope of Jesus with the world, and impact lives.
          </Text>
        </TextBox>
        <Image src={HoursGrid} />
      </Box>
    </Container>
  );
};

const Container = styled.section`
  margin: 0;
  position: relative;
  width: 100vw;

  padding: 4rem 1.2rem;

  ${media.tabletLandscapeAndUp`
    padding-bottom: 10rem;
  `}
`;

const Header = styled(H3)`
  text-align: center;
  margin-left: 8rem;
  margin-right: 8rem;
`;

const Headline = styled(H5)`
  font-weight: 700;
  font-size: 2.8rem;
  line-height: calc(2.2 / 2.8 * 1em);
  letter-spacing: calc(-0.5 / 2.8 * 0.1em);
  margin: 0;

  ${media.tabletPortraitAndUp`
    font-size: 3.7rem;
    line-height: calc(3 / 3.7 * 1em);
    letter-spacing: calc(-0.7 / 3.7 * 0.1em);
  `}
`;

const Text = styled.p`
  font-weight: 300;
  font-size: 1.8rem;
  line-height: calc(2.2 / 1.8 * 1em);
  letter-spacing: calc(-0.5 / 1.8 * 0.1em);
  margin: 1em 0;

  ${media.tabletPortraitAndUp`
    font-size: 2.4rem;
    line-height: calc(3 / 2.4 * 1em);
    letter-spacing: calc(-0.5 / 2.4 * 0.1em);
  `}
`;

const Box = styled.div`
  padding: 5.8rem 2.8rem 4.5rem 3.4rem;
  border-radius: 4.2rem;

  background-color: var(--colorBlack);
  color: var(--colorWhite);

  max-width: 50rem;
  margin-left: auto;
  margin-right: auto;

  ${media.tabletPortraitAndUp`
    max-width: 70rem;
    padding: 6rem 6rem 7rem 7rem;
  `}

  ${media.tabletLandscapeAndUp`
    padding: 8rem 8rem 10rem 11rem;
  `}

  ${media.mediumDesktopAndUp`
    max-width: 120rem;
    padding-right: 8%;
    padding-top: 5%;

    display: flex;
    justify-content: center;
    align-items: flex-start;
    border-radius: 7rem;

    padding: 8rem 4rem 7rem 11rem;
`}
`;

const Image = styled.img`
  max-width: 100%;
  padding-right: 2rem;

  ${media.mediumDesktopAndUp`
    width: 44%;
  `}
`;

const TextBox = styled.div`
  position: relative;
  z-index: 2;

  margin-bottom: 4rem;

  ${media.mediumDesktopAndUp`
    padding-top: 5%;
    padding-right: 14%;
  `}
`;



// WEBPACK FOOTER //
// ./src/routes/Home/components/SectionThisWay.js